<div class="content-card mat-white-bg">

  <div class="content pos-relative flex flex-col">
    <div class="keno-grid-container">
      <particle-virtual-grid [sourceKey]="sourceKey" 
      (valueChanged)="onGridCellValueChange($event)"
      >
      </particle-virtual-grid>
    </div>
  </div>
</div>
